export default {
  // Default variant
  //-------------------------------------------------------------------------
  default: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-text mb-1",
    dropdown_button:
      "h-[42px] bg-paper flex items-center justify-between cursor-pointer border border-bordered rounded-lg px-4 py-2 ",
    dropdown_icon: "w-5 h-5 text-text_secondary mr-2",
    chevron_icon: "w-5 h-5 text-text_secondary",
    dropdown_text: "text-text",
    popup:
      "absolute right-0 text-text bg-paper border border-bordered rounded-lg shadow-lg mt-1 p-2 w-64 z-50",
    popup_scroll: "max-h-72 overflow-y-auto",
    preset_item: {
      base: "cursor-pointer flex items-center justify-between rounded-md px-4 py-2",
      active: "bg-primary/10 text-primary",
      hover: "hover:bg-canvas",
    },
    preset_check_icon: "w-5 h-5",
    custom_section: "border-t border-bordered pt-3 mt-3",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
  },

  admin: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-admin_text_secondary mb-0.5",
    dropdown_button:
      "h-10 bg-admin_paper flex items-center justify-between cursor-pointer border border-admin_bordered rounded-lg px-4 py-2",
    dropdown_icon: "w-5 h-5 text-admin_text_secondary mr-2",
    chevron_icon: "w-5 h-5 text-admin_text_secondary",
    dropdown_text: "text-admin_text",
    popup:
      "absolute right-0 text-admin_text bg-admin_paper border border-admin_bordered rounded-lg shadow-lg mt-1 p-2 w-full z-50",
    popup_scroll: "max-h-72 overflow-y-auto",
    preset_item: {
      base: "cursor-pointer flex items-center justify-between rounded-md px-4 py-2",
      active: "bg-admin_primary/10 text-admin_primary",
      hover: "hover:bg-admin_primary/5",
    },
    preset_check_icon: "w-5 h-5",
    custom_section: "border-t border-admin_bordered pt-3 mt-3",
    highlight: "ring-2 ring-admin_primary ring-opacity-50 border-admin_primary",
  },

  // Compact variant with smaller sizes
  //-------------------------------------------------------------------------
  compact: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-text mb-0.5 text-xs",
    dropdown_button:
      "px-3 py-1.5 bg-paper flex items-center justify-between cursor-pointer border border-bordered rounded-lg h-[36px] text-sm",
    dropdown_icon: "w-4 h-4 text-text_secondary mr-1.5",
    chevron_icon: "w-4 h-4 text-text_secondary",
    dropdown_text: "text-text",
    popup:
      "absolute z-50 bg-paper border border-bordered rounded-lg shadow-lg mt-1 p-1.5 w-56 right-0",
    popup_scroll: "max-h-64 overflow-y-auto",
    preset_item: {
      base: "flex items-center justify-between rounded-md text-sm cursor-pointer px-3 py-1.5",
      active: "bg-primary/10 text-primary",
      hover: "hover:bg-canvas",
    },
    preset_check_icon: "w-4 h-4",
    custom_section: "border-t border-bordered pt-2 mt-2",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
  },

  admin_compact: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-admin_text mb-0.5 text-xs",
    dropdown_button:
      "h-[36px] flex items-center justify-between text-sm bg-admin_paper cursor-pointer border border-admin_bordered rounded-lg px-3 py-1.5",
    dropdown_icon: "w-4 h-4 text-admin_text_secondary mr-1.5",
    chevron_icon: "w-4 h-4 text-admin_text_secondary",
    dropdown_text: "text-admin_text",
    popup:
      "absolute right-0 w-56 bg-admin_paper border border-admin_bordered rounded-lg shadow-lg p-1.5 mt-1 z-50",
    popup_scroll: "max-h-64 overflow-y-auto",
    preset_item: {
      base: "flex items-center justify-between rounded-md text-sm cursor-pointer px-3 py-1.5",
      active: "bg-admin_primary/10 text-admin_primary",
      hover: "hover:bg-admin_canvas",
    },
    preset_check_icon: "w-4 h-4",
    custom_section: "border-t border-admin_bordered pt-2 mt-2",
    highlight: "ring-2 ring-admin_primary ring-opacity-50 border-admin_primary",
  },

  // Large variant with increased sizes
  //-------------------------------------------------------------------------
  large: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-text text-base mb-2",
    dropdown_button:
      "h-[50px] flex items-center justify-between text-lg bg-paper cursor-pointer border border-bordered rounded-lg px-5 py-3",
    dropdown_icon: "w-6 h-6 text-text_secondary mr-3",
    chevron_icon: "w-6 h-6 text-text_secondary",
    dropdown_text: "text-text",
    popup:
      "absolute right-0 w-72 bg-paper border border-bordered rounded-lg shadow-lg mt-1 p-3 z-50",
    popup_scroll: "max-h-80 overflow-y-auto",
    preset_item: {
      base: "cursor-pointer flex items-center justify-between rounded-md text-lg px-5 py-2.5",
      active: "bg-primary/10 text-primary",
      hover: "hover:bg-canvas",
    },
    preset_check_icon: "w-6 h-6",
    custom_section: "border-t border-bordered pt-3 mt-4",
    highlight: "ring-2 ring-primary ring-opacity-50 border-primary",
  },

  admin_large: {
    root: "relative w-full",
    wrapper: "flex flex-col",
    label: "text-admin_text text-base mb-2",
    dropdown_button:
      "h-[50px] flex items-center justify-between text-lg bg-admin_paper border border-admin_bordered cursor-pointer rounded-lg px-5 py-3",
    dropdown_icon: "w-6 h-6 text-admin_neutral_3 mr-3",
    chevron_icon: "w-6 h-6 text-admin_neutral_3",
    dropdown_text: "text-admin_text",
    popup:
      "absolute right-0 w-72 bg-admin_paper border border-admin_bordered rounded-lg shadow-lg p-3 mt-1 z-50",
    popup_scroll: "max-h-80 overflow-y-auto",
    preset_item: {
      base: "flex items-center justify-between  text-lg rounded-md cursor-pointer px-5 py-2.5",
      active: "text-admin_primary bg-admin_primary/10",
      hover: "hover:bg-admin_canvas",
    },
    preset_check_icon: "w-6 h-6",
    custom_section: "border-t border-admin_bordered pt-3 mt-4",
    highlight: "ring-2 ring-admin_primary ring-opacity-50 border-admin_primary",
  },
}